// Hook de React Query pro dashboard de pipeline comercial (Story 11.12).
// 1 request consolidado (cards + funil + conversão + a vencer) — os filtros
// (período + responsável) fazem parte da queryKey, então mudar o filtro refaz a
// query (afeta todos os widgets simultaneamente — AC6).

import { useQuery } from '@tanstack/react-query';
import type { PipelinePeriod } from '@control-center/shared';

import { fetchPipelineSummary, type PipelineSummaryParams } from '../lib/crm-pipeline-api';

export const crmPipelineKeys = {
  all: ['crm-pipeline'] as const,
  summary: (params: PipelineSummaryParams) => [...crmPipelineKeys.all, 'summary', params] as const,
};

export function useCrmPipelineSummary(period: PipelinePeriod, responsibleUserId?: string) {
  const params: PipelineSummaryParams = { period };
  if (responsibleUserId) params.responsibleUserId = responsibleUserId;
  return useQuery({
    queryKey: crmPipelineKeys.summary(params),
    queryFn: ({ signal }) => fetchPipelineSummary(params, signal),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
